import styled from 'styled-components'

import type { InputProps } from '../InputElements'
import { Input } from '../InputElements'
import { FormControl } from './FormControl'
import { FormHelperText } from './FormHelperText'

export enum AdornmentType {
  end = 'endAdornment',
  start = 'startAdornment',
}

const StyledInput = styled(Input)<{ $textAlign: 'left' | 'right' }>`
  font-size: 14px;
  text-align: ${({ $textAlign }) => $textAlign};
`

const StyledFormControl = styled(FormControl)`
  margin: 0;
  font-size: 14px;
`

interface CustomFieldBehaviorProps extends InputProps {
  adornmentType?: AdornmentType
  disabled: boolean
  error: boolean
  formattedCurrency?: string
  helperText: string
  textAlign?: 'left' | 'right'
}

export function CustomFieldBehavior({
  adornmentType,
  formattedCurrency,
  helperText,
  textAlign = 'right',
  ...rest
}: CustomFieldBehaviorProps) {
  return (
    <StyledFormControl error={Boolean(rest.error)}>
      <StyledInput
        $textAlign={textAlign}
        {...rest}
        {...(adornmentType &&
          formattedCurrency && {
            [adornmentType]: formattedCurrency,
          })}
      />
      {rest.error && <FormHelperText>{helperText}</FormHelperText>}
    </StyledFormControl>
  )
}
